import axiosInstance from "../../../interceptor/intercetptor-inctence";


export const frequentlyDiagnosedDiseaseAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/problems/graph`, data);
}

export const mostPrescribedMedicineAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/prescribed_medicine/graph`, data);
}
export const doctorWithMostAppointmentsAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/doctor/appointments`, data);
}

export const countsAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/count`, data);
}

export const appointmentSummaryAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/appointment/graph`, data);
}

export const patientVisitingAPI = (data) => {
    return axiosInstance.post(`clinic_admin/dashboard/appointment/chart`, data);
}

export const getSalesGraphAPI = (data) => {
    return axiosInstance.post(`pharma/get-payment-trends`, data)
}
